export const BADGE_STATUT = {
    REJETE: 'rejeté',
    SOUMIS: 'soumis',
    REFUSE: 'refusé',
    TRAITE: 'traité',
    NON_TRAITE: 'non-traité',
    CLOTURE: 'clôturé',
    NON_CLOTURE: 'non-clôturé',
    ACCEPTE: 'accepté',
    ABANDONNE: 'abandonné',
};
